import { RouteItem } from '@eastcoal/router/types/route'

import { NEWS_HOME_PAGE_PATH } from './constants/path'

export const newsHomeRoute: RouteItem = {
  title: '行业资讯',
  path: NEWS_HOME_PAGE_PATH,
  Component: () => import('./index')
}
